var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "YAY",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.154,
    height: 79.008,
    viewBox: "0 0 148.154 79.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M54.576,6.609a39.443,39.443,0,0,1-4.315,5.568,35.394,35.394,0,0,0-4.144,5.341q-1.065,1.872-13.5,34.046Q22.079,79,18.606,79a8.605,8.605,0,0,1-5.268-1.655,5.383,5.383,0,0,1-2.578-4.63q0-1.765,2.019-4.41t4.486-9.363q1.8-5.063,3.584-10.139Q14.121,43.516,8.971,32.6-.007,14,0,6.389,0,.006,5.827,0q6.728,0,6.722,7.6a14.709,14.709,0,0,1-.283,2.367,15.075,15.075,0,0,0-.283,2.477q0,4.627,4.374,14.543Q20.954,37.457,24.651,39q1.46-2.1,6.386-12.674,5.377-11.678,8.405-16.748,5.041-8.264,8.405-8.264A7.153,7.153,0,0,1,52.274,2.8a5.632,5.632,0,0,1,2.3,3.8",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M-276.274-362.672H54.4V-687.788H-276.274v325.116",
    transform: "translate(276.274 687.788)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M197.842,57.037q0,5.286-4.821,5.4a39.044,39.044,0,0,0,2.466,6.829,5.217,5.217,0,0,1-2.019,3.964,6.908,6.908,0,0,1-4.486,1.545,11.773,11.773,0,0,1-4.709-1.209,14.878,14.878,0,0,1-1.454-6.829c0-.66.039-1.617.112-2.865s.112-2.166.112-2.755c0,.517-1.23.77-3.7.77q-6.274,0-14.9.55-12.332.66-13.391,1.875t-1.4,11.788a4.359,4.359,0,0,1-3.7,2.1,7.9,7.9,0,0,1-4.821-1.927q-2.466-1.93-2.466-4.132a37.172,37.172,0,0,1,2.019-6.169q2.239-7.818,7.287-23.467Q162.99,2.053,172.961,2.053c6.649,0,11.5,7.126,15.015,21.378q2.358,9.583,4.374,29.423a17.539,17.539,0,0,1,3.7,1.1,3.285,3.285,0,0,1,1.8,3.085m-15.693-4.19Q177.216,14.4,173.3,14.391q-3.137,0-10.984,18.067-5.6,13.007-8.853,22.587,3.581-.766,10.648-1.875a122.853,122.853,0,0,1,18.041-.33",
    transform: "translate(-138.668 -2.053)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M398.2,6.591a39.44,39.44,0,0,1-4.315,5.568A35.4,35.4,0,0,0,389.74,17.5q-1.065,1.872-13.5,34.046Q365.7,78.987,362.228,78.983a8.606,8.606,0,0,1-5.268-1.655,5.383,5.383,0,0,1-2.578-4.63q0-1.765,2.019-4.41t4.486-9.363q1.8-5.063,3.585-10.139-6.728-5.286-11.878-16.2-8.968-18.623-8.965-26.222,0-6.392,5.827-6.389,6.728,0,6.722,7.6a14.715,14.715,0,0,1-.283,2.367,15.846,15.846,0,0,0-.283,2.477q0,4.627,4.374,14.543,4.6,10.466,8.294,12.008,1.45-2.1,6.386-12.674,5.377-11.678,8.405-16.748,5.041-8.264,8.405-8.264A7.153,7.153,0,0,1,395.9,2.776a5.632,5.632,0,0,1,2.3,3.8",
    transform: "translate(-343.629 0.024)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0 0.006)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(-75.241 -184.166)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M38.6,57.53,16.647,79.115a5.375,5.375,0,0,0,2.578,4.462,8.647,8.647,0,0,0,5.268,1.655q3.473,0,14.009-27.437l.1-.265M18.4,12.723,8.09,22.863a148.191,148.191,0,0,0,6.761,15.979c.6,1.274,1.217,2.483,1.848,3.641l6.755-6.641q-.592-1.232-1.2-2.619-4.37-9.913-4.374-14.543A14.931,14.931,0,0,1,18.16,16.2a15.7,15.7,0,0,0,.283-2.367c0-.382-.013-.75-.039-1.1M51.262,8.5a14.628,14.628,0,0,0-2.69,2.645L51.262,8.5",
    transform: "translate(69.354 177.941)",
    fill: "#e9c5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M5.827,0Q0,0,0,6.389A34.177,34.177,0,0,0,2.2,16.638L12.516,6.5Q12.043,0,5.827,0",
    transform: "translate(75.241 184.166)",
    fill: "#c84f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M76.586,4.951a4.328,4.328,0,0,0-2.48.957l-2.69,2.645a42.174,42.174,0,0,0-3.236,4.662q-3.029,5.073-8.405,16.748-4.933,10.582-6.386,12.674Q50.183,41.3,46.3,33.248l-6.755,6.641a40.261,40.261,0,0,0,10.03,12.558q-1.8,5.073-3.584,10.139Q43.523,69.308,41.5,71.95c-1.342,1.765-2.019,3.233-2.019,4.41v.168L61.439,54.943q12.342-31.922,13.4-33.787a35.966,35.966,0,0,1,4.144-5.341A39.444,39.444,0,0,0,83.3,10.247a5.671,5.671,0,0,0-2.3-3.8,7.153,7.153,0,0,0-4.426-1.487",
    transform: "translate(46.51 180.541)",
    fill: "#c84f8d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(37.765 0.556)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(-113.006 -184.715)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M197.217,66.772,182.952,80.8a13.679,13.679,0,0,0,1.329,4.6,11.747,11.747,0,0,0,4.709,1.209,6.9,6.9,0,0,0,4.486-1.546,5.217,5.217,0,0,0,2.019-3.964,39.044,39.044,0,0,1-2.466-6.829q4.814-.107,4.821-5.4a3.425,3.425,0,0,0-.631-2.1M170.83,28.051,150.29,48.246q-1.144,2.91-2.315,6.079-5.041,15.646-7.287,23.467a38.129,38.129,0,0,0-2.019,6.169,4.368,4.368,0,0,0,1.052,2.761l21.638-21.275q-5.041.824-7.892,1.436,3.246-9.583,8.853-22.587,5.347-12.328,8.511-16.244m10-9.836-8.511,8.368a1.806,1.806,0,0,1,.98-.362q2.91,0,6.38,21.2l9.037-8.885q-.365-1.775-.737-3.285-2.9-11.756-7.149-17.046",
    transform: "translate(-25.662 170.832)",
    fill: "#e9c5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M204.012,2.053q-9.195,0-22.671,34.363l20.54-20.195a7.3,7.3,0,0,1,1.493-1.468l8.511-8.368Q208.4,2.05,204.019,2.053",
    transform: "translate(-56.713 182.663)",
    fill: "#c84f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M191.514,94.16l-9.037,8.885q1.2,7.352,2.473,17.246-4.232-.155-7.774-.162a87.9,87.9,0,0,0-10.273.491c-.967.149-1.888.3-2.756.44l-21.638,21.275a8.3,8.3,0,0,0,1.414,1.371,7.866,7.866,0,0,0,4.821,1.927,4.257,4.257,0,0,0,3.7-2.1q.335-10.582,1.4-11.788t13.391-1.875q8.632-.553,14.9-.55,3.7,0,3.7-.77c0,.588-.039,1.507-.112,2.755s-.112,2.205-.112,2.865a18.71,18.71,0,0,0,.125,2.231L200,122.38a3.477,3.477,0,0,0-1.164-.989,17.675,17.675,0,0,0-3.7-1.1q-1.7-16.693-3.637-26.131",
    transform: "translate(-28.456 115.218)",
    fill: "#c84f8d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(93.584)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(-168.826 -184.159)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M396.885,3.744,375.266,25l-.618,1.332q-4.933,10.582-6.386,12.674a9.606,9.606,0,0,1-3.709-3.473l-6.544,6.434a34.1,34.1,0,0,0,6.439,6.842q-1.8,5.073-3.585,10.139-2.466,6.722-4.485,9.363c-1.342,1.765-2.019,3.233-2.019,4.41a6.069,6.069,0,0,0,.059.854L375.851,52.5c.118-.31.237-.621.362-.938q12.44-32.174,13.5-34.046a35.965,35.965,0,0,1,4.144-5.341,39.45,39.45,0,0,0,4.315-5.568,5.542,5.542,0,0,0-1.3-2.871M349.432,0Q343.6,0,343.6,6.389q0,3.928,2.394,10.806L356.153,7.21Q355.986-.006,349.432,0",
    transform: "translate(-174.785 184.166)",
    fill: "#e9c5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M362.55,10.835l-10.155,9.984a152.638,152.638,0,0,0,6.57,15.423,57.632,57.632,0,0,0,5.439,9.351l6.544-6.434a48.772,48.772,0,0,1-4.584-8.542q-4.37-9.913-4.374-14.543a14.936,14.936,0,0,1,.283-2.477,15.693,15.693,0,0,0,.283-2.367v-.388m35.3-5.891q-3.364,0-8.405,8.264-2.851,4.772-7.787,15.416L403.281,7.369a6.488,6.488,0,0,0-1-.931,7.153,7.153,0,0,0-4.426-1.487",
    transform: "translate(-181.182 180.541)",
    fill: "#c84f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M404.765,196.073l-21.435,21.074a5.446,5.446,0,0,0,2.519,3.776,8.647,8.647,0,0,0,5.268,1.655q3.413,0,13.647-26.5",
    transform: "translate(-203.693 40.594)",
    fill: "#c84f8d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYay);
export default __webpack_public_path__ + "static/media/YAY.b845d7ea7bf720c2479b36a5620b287c.svg";
export { ForwardRef as ReactComponent };